import React from "react";

const CountdownTimer = ({
  time,
  isRunning,
  formatTime,
  startTimer,
  stopTimer,
}) => {
  return (
    <div className="col-lg-12 mt-2">
      <div className="countdown_blk">
        <h3 className="fs-6 text-center mb-0">Scout Time</h3>
        <h4 className="fs-4 fw-bold mb-0 text-center">{formatTime(time)}</h4>
        <div className="hstack justify-content-center gap-4">
          <button
            className="primary-btn"
            onClick={startTimer}
            disabled={isRunning}
          >
            Start
          </button>
          <button
            className="primary-outline-btn outline-btn"
            onClick={stopTimer}
            disabled={!isRunning}
          >
            Stop
          </button>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;
